









import Vue from 'vue'
import ElementMixin from './ElementMixin'

export default Vue.extend({
  mixins: [ElementMixin],
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
})
